import { TabPanel, useTabs } from "react-headless-tabs";
import { TabSelector } from "../ui/TabSelector";
import Trustspot from "../trustspot/Trustspot";
import ImageGallery from "react-image-gallery";
import Carousel from 'react-multi-carousel';
import DOMPurify from "dompurify";

import 'react-multi-carousel/lib/styles.css';
import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';
import classes from './ProductDetails.module.css';
import Image from '../ui/Image';
import AddToCart from '../ui/AddToCart';

function ProductDetails(props) {
	const responsive = {
		desktop: {
			breakpoint: { max: 5000, min: 464 },
			items: 3
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1
		}
	};

	props.product.media.img.forEach((image, index) => {
		props.product.media.img[index].original = "https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/webp/" + image.filename_webp;
		props.product.media.img[index].thumbnail = "https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/webp/" + image.filename_webp;
	});

	const properties = {
		showThumbnails: props.product.media.img.length > 1 ? true : false,
		thumbnailPosition: "left",
		showFullscreenButton: true,
		showPlayButton: props.product.media.img.length > 1 ? true : false,
		autoPlay: true,
		disableThumbnailScroll: false,
		items: props.product.media.img
	};

	const [selectedTab, setSelectedTab] = useTabs([
		"details",
		"documents",
		"parts",
		"reviews",
	]);

	return (
		<section>
			<div className={classes.image_container}>
				<ImageGallery {...properties} />
			</div>
			<div className={classes.clearfix}></div>
			<div className={classes.product_tabs}>
				<nav>
					<TabSelector isActive={selectedTab === "details"} onClick={() => setSelectedTab("details")}>Details</TabSelector>
					{typeof(props.product.media.doc) !== "undefined" && 
						<TabSelector isActive={selectedTab === "documents"} onClick={() => setSelectedTab("documents")}>Documents</TabSelector>
					}
					{typeof(props.product.product_relations["Replacement Parts"]) !== "undefined" && 
						<TabSelector isActive={selectedTab === "parts"} onClick={() => setSelectedTab("parts")}>Parts</TabSelector>
					}
					{(typeof(props.product.id) !== "undefined") && 
						<TabSelector isActive={selectedTab === "reviews"} onClick={() => setSelectedTab("reviews")}>Reviews</TabSelector>
					}
				</nav>
				<hr className={classes.hr}/>
				<div className="p-4">
					<TabPanel hidden={selectedTab !== "details"} className={classes.description}>{ <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.product.description) }} /> }</TabPanel>
					<TabPanel hidden={selectedTab !== "documents"} className={classes.documents}>
						<ul className={classes.docList}>
							{typeof(props.product.media.doc) !== "undefined" && props.product.media.doc.map((doc) => (
							<li key={doc.id}>
								<a href={"https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/" + doc.content} target="_blank" rel="noreferrer">{doc.type}</a>
							</li>
							))}
						</ul>
					</TabPanel>
					<TabPanel hidden={selectedTab !== "parts"} className={classes.parts}>
						<Carousel responsive={responsive}>
							{typeof(props.product.product_relations["Replacement Parts"]) !== "undefined" && props.product.product_relations["Replacement Parts"].map((part) => (
								<div key={"container" + part.id} className={classes.inner_container}>
									<div key={"container" + part.id} className={classes.image_container}>
										<Image
											key={part.id}
											id={part.id}
											name={part.name}
											filename={part.filename}
											filetype={part.filetype}
											filename_webp={part.filename_webp}
										/>
									</div>
									<a key={"link" + part.id} href={"/product/sku/" + part.sku} ><div key={"name" + part.id} className={classes.name} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(part.name)}} /></a>
									$<span key={"price" + part.id} className={classes.price}>{part.pricing.lowest.price}</span>
									<AddToCart key={"addtocart" + part.id} product={part} showQuantity={false}/>
								</div>
							))}
						</Carousel>
					</TabPanel>
					<TabPanel hidden={selectedTab !== "reviews"} className={classes.reviews}>
						<Trustspot product={props.product} trustspotReviews={props.trustspotReviews} type={'reviews'}/>
					</TabPanel>
				</div>
			</div>
		</section>
	);
}

export default ProductDetails;
